<!-- footer -->
<footer class="col-md-12 col-sm-12 row m-0 px-0 py-2">
  <div class="col-md-10 offset-md-1 my-auto">
    <p class="col-12 font-12 text-center fw-800 mb-1 mt-3"><a href="/terms-and-conditions" target="_blank">Terms and Conditions</a><span class="ml-2"><a href="/privacy-and-policy" target="_blank">Privacy Policy</a></span><span class="ml-2"><a href="/child-safety-policy" target="_blank">Child Safety Policy</a></span></p>


    <p class="font-12 text-center">Copyright CitizeX. All Rights Reserved - Version {{ version }} - {{ date }}</p>
  </div>
  <!-- .col -->
</footer>
<!-- footer Ends -->
